"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withInputValues;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _initState = _interopRequireDefault(require("./helpers/initState"));

var _setComponentDisplayName = _interopRequireDefault(require("../helpers/setComponentDisplayName"));

var _toKebabCase = _interopRequireDefault(require("../helpers/toKebabCase"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function withInputValues(WrappedComponent, validator, EventHandler) {
  var passState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var InputValues = /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(InputValues, _Component);

    var _super = _createSuper(InputValues);

    function InputValues(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, InputValues);
      _this = _super.call(this, props);
      var customValidator = _this.props.customValidator;
      _this.passState = passState;
      _this.displayName = (0, _setComponentDisplayName["default"])(WrappedComponent, props.classPrefixOverride);
      _this.state = (0, _initState["default"])(props, passState, _this.displayName);
      _this.setStateValues = _this.setStateValues.bind((0, _assertThisInitialized2["default"])(_this));
      _this.checkInitialProps = _this.checkInitialProps.bind((0, _assertThisInitialized2["default"])(_this));
      _this.validator = customValidator ? customValidator.bind((0, _assertThisInitialized2["default"])(_this)) : validator.bind((0, _assertThisInitialized2["default"])(_this));
      _this.eventHandler = new EventHandler(_this.setStateValues);
      return _this;
    }

    (0, _createClass2["default"])(InputValues, [{
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.setValid();

                case 2:
                  _context.next = 4;
                  return this.checkInitialProps();

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: function () {
        var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(prevProps, prevState) {
          var _this$state, storedValue, isValid, _this$props, validateControls, resetForm;

          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this$state = this.state, storedValue = _this$state.storedValue, isValid = _this$state.isValid;
                  _this$props = this.props, validateControls = _this$props.validateControls, resetForm = _this$props.resetForm;

                  if (!(storedValue !== prevState.storedValue)) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return this.setValid();

                case 5:
                  if (isValid !== prevState.isValid) {
                    this.sendReportControlValues();
                  }

                  if (!(prevProps.validateControls !== validateControls)) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return this.validate();

                case 9:
                  if (prevProps.resetForm !== resetForm) {
                    this.setStateValues((0, _initState["default"])(this.props, this.passState, this.displayName));
                  }

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function componentDidUpdate(_x, _x2) {
          return _componentDidUpdate.apply(this, arguments);
        }

        return componentDidUpdate;
      }()
    }, {
      key: "setStateValues",
      value: function setStateValues(updatedValues) {
        var _this2 = this;

        this.setState(updatedValues, function () {
          _this2.sendReportControlValues();
        });
      }
    }, {
      key: "setValid",
      value: function () {
        var _setValid = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var isValid;
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.validator(this.state, this.props);

                case 2:
                  isValid = _context3.sent;
                  this.setState(function () {
                    return {
                      isValid: isValid
                    };
                  }, this.sendReportControlValues);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function setValid() {
          return _setValid.apply(this, arguments);
        }

        return setValid;
      }()
    }, {
      key: "sendReportControlValues",
      value: function sendReportControlValues() {
        var _this$props2 = this.props,
            fieldData = _this$props2.fieldData,
            reportControlValues = _this$props2.reportControlValues;
        var fieldId = fieldData.id,
            fieldKey = fieldData.fieldKey;

        var controlProps = _objectSpread({
          fieldId: fieldId,
          fieldKey: fieldKey
        }, this.state);

        reportControlValues(controlProps);
      }
    }, {
      key: "checkInitialProps",
      value: function () {
        var _checkInitialProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          var _this$props$fieldData, customError, checkInitialValue, value;

          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this$props$fieldData = this.props.fieldData, customError = _this$props$fieldData.customError, checkInitialValue = _this$props$fieldData.checkInitialValue, value = _this$props$fieldData.value;

                  if (!customError) {
                    _context4.next = 5;
                    break;
                  }

                  this.setStateValues({
                    isValid: false,
                    complete: true
                  });
                  _context4.next = 11;
                  break;

                case 5:
                  if (!checkInitialValue) {
                    _context4.next = 10;
                    break;
                  }

                  _context4.next = 8;
                  return this.validate();

                case 8:
                  _context4.next = 11;
                  break;

                case 10:
                  if (value) {
                    this.setStateValues({
                      complete: true
                    });
                  }

                case 11:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function checkInitialProps() {
          return _checkInitialProps.apply(this, arguments);
        }

        return checkInitialProps;
      }()
    }, {
      key: "validate",
      value: function () {
        var _validate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          var isValid;
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.validator(this.state, this.props);

                case 2:
                  isValid = _context5.sent;
                  this.setStateValues({
                    isValid: isValid,
                    complete: true
                  });
                  return _context5.abrupt("return", isValid);

                case 5:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function validate() {
          return _validate.apply(this, arguments);
        }

        return validate;
      }()
    }, {
      key: "render",
      value: function render() {
        var isFocused = this.state.isFocused;
        var extraProps = {
          eventHandler: this.eventHandler,
          classPrefix: (0, _toKebabCase["default"])(this.displayName),
          isFocused: isFocused
        };

        var controlProps = _objectSpread(_objectSpread({}, extraProps), this.props);

        delete controlProps.classPrefixOverride;
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, controlProps, this.state));
      }
    }]);
    return InputValues;
  }(_react.Component);

  InputValues.propTypes = {
    fieldData: _propTypes["default"].shape({}).isRequired,
    fieldId: _propTypes["default"].string.isRequired,
    classPrefixOverride: _propTypes["default"].string,
    reportControlValues: _propTypes["default"].func.isRequired,
    validateControls: _propTypes["default"].string,
    resetForm: _propTypes["default"].string,
    customValidator: _propTypes["default"].func
  };
  InputValues.defaultProps = {
    classPrefixOverride: '',
    validateControls: undefined,
    resetForm: undefined,
    customValidator: undefined
  };
  return InputValues;
}